import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Profilepassword = () => {
  const [state, setState] = useState({
    password: "",
    password2: "",
    confirm_password: "",
    errorMessage: "",
    errorMessage1: "",
    handleChange: false,
  });

  console.log(state);
  const [visible, setVisible] = useState(true);

  const onDismiss = () => setVisible(false);

  const handleEditChange = (e) => {
    const { id, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const Submit = (e) => {
    e.preventDefault();
    const login = {
      email: window.localStorage.getItem("email").toString(),
      password: state.password,
    };
    fetch(`${process.env.REACT_APP_API_URL}/auth/login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(login),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.tokens && data.email && data.username) {
          window.localStorage.setItem("user", data.username);
          window.localStorage.setItem("email", data.email);
          window.localStorage.setItem("token", data.tokens.access);
          toggle1();
        } else {
          if (data.password) {
            setState({ errorMessage: data.password[0] });
          } else if (data.detail) {
            setState({ errorMessage: data.detail });
          } else {
            setState({ errorMessage: data.detail });
          }
        }
      })
      .catch((error) => {
        console.error(error);
        window.localStorage.removeItem("token");
        window.location.href = "/something_went_wrong";
      });
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (state.confirm_password !== state.password2) {
      setState({ errorMessage1: "The passwords doesn't match" });
    } else {
      const usrprofile = {
        username: "",
        password: state.password2,
        groups: "",
        organization_name: "",
        address: "",
      };
      fetch(
        `${process.env.REACT_APP_API_URL}/api/user_management/editprofile`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("token"),
          },
          body: JSON.stringify(usrprofile),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
          window.location.reload();
        });
      window.location.reload();
    }
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const toggle = () => setOpen(!open);

  const [open1, setOpen1] = useState(false);
  const toggle1 = () => setOpen1(!open1);

  const handleClickOpen1 = () => {
    setOpen(true);
  };

  const handleClose1 = () => {
    setOpen(false);
  };

  function refreshPage() {
    window.location.reload();
  }
  return (
    <>
      {window.localStorage.getItem("google") === "google" ? (
        <React.Fragment>
          <button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="button"
            disabled="true"
          >
            Change Password
          </button>
          <IconButton
            sx={{
              color: "white",
              "&.Mui-checked": {
                color: "white",
              },
            }}
            size="sm"
            title="As you are using google account, you can't change your password"
            data-toggle="collapse"
            style={{ marginTop: "29px" }}
          >
            <InfoIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      ) : (
        <button
          className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-sm px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          type="button"
          onClick={toggle}
          style={{ marginTop: "30px", width: "80%" }}
        >
          Change Password
        </button>
      )}
      <Dialog
        PaperProps={{
          sx: {
            width: "100%",
          },
        }}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <div>
            {state.errorMessage && (
              <Alert color="danger" isOpen={visible} toggle={onDismiss}>
                {" "}
                {state.errorMessage}{" "}
              </Alert>
            )}
          </div>
          <form>
            <div className="head" style={{ height: "80px" }}>
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "810",
                  color: "rgb(48, 68, 115)",
                  fontFamily: "sans-serif",
                  lineHeight: "4.5rem",
                }}
              >
                Current Password
              </h2>
            </div>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <TextField
                placeholder="Password"
                type="password"
                id="password"
                name="password"
                size="small"
                value={state.password}
                onChange={handleEditChange}
              />
            </FormGroup>
          </form>
        </DialogContent>
        <DialogActions>
          <button
            className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={refreshPage}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={Submit}
          >
            Confirm
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        PaperProps={{
          sx: {
            width: "80%",
          },
        }}
        open={open1}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose1}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <div>
            {state.errorMessage1 && (
              <Alert color="danger" isOpen={visible} toggle={onDismiss}>
                {" "}
                {state.errorMessage1}{" "}
              </Alert>
            )}
          </div>
          <form>
            <div className="head" style={{ height: "80px" }}>
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "810",
                  color: "rgb(48, 68, 115)",
                  fontFamily: "sans-serif",
                  lineHeight: "4.5rem",
                }}
              >
                Set New Password
              </h2>
            </div>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <TextField
                placeholder="Password"
                type="password"
                id="password2"
                name="password2"
                size="small"
                value={state.password2}
                onChange={handleEditChange}
              />
            </FormGroup>
            <FormGroup style={{ marginBottom: "2.5rem" }}>
              <TextField
                placeholder="Confirm Password"
                type="password"
                id="confirm_password"
                name="confirm_password"
                size="small"
                value={state.confirm_password}
                onChange={handleEditChange}
              />
            </FormGroup>
          </form>
        </DialogContent>
        <DialogActions>
          <button
            className="bg-blueGray-100 text-black font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            onClick={toggle1}
          >
            Cancel
          </button>
          <button
            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            type="submit"
            onClick={HandleSubmit}
          >
            Confirm
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Profilepassword;
